module.exports = __webpack_public_path__ + "assets/images/53597a084290e8f85e66fb4dd5ebf139.svg";